module.exports = __webpack_public_path__ + "img/guizhouHints_2.c2bf2b93.jpg";